export enum EnumDepOperatorCodes {

  Plus = '+',
  Equal = '=',
  NotEqual = '!=',
  TxtHeader = 'hdr',
  TxtQuestion = 'qu',
  SetValue = 'val',
  Formula = 'f',
  f_Equal = 'f=',
  f_NotEqual = 'f!='
}

